import { render, staticRenderFns } from "./StatWidget.vue?vue&type=template&id=118d2765&scoped=true&"
import script from "./StatWidget.vue?vue&type=script&lang=js&"
export * from "./StatWidget.vue?vue&type=script&lang=js&"
import style0 from "./StatWidget.vue?vue&type=style&index=0&id=118d2765&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118d2765",
  null
  
)

export default component.exports